import { ReactNode } from 'react'
import EmbeddedVideoGalleryPreview from 'modules/community/components/attachment-gallery/embedded-video-preview/embedded-video-gallery-preview'
import { GifGalleryPreview } from 'modules/community/components/attachment-gallery/gif-gallery-preview'
import ImageGalleryPreview from 'modules/community/components/attachment-gallery/image-gallery-preview'
import VideoGalleryPreview from 'modules/community/components/attachment-gallery/video-gallery-preview'
import { AttachmentTypeEnum, PostAttachmentType } from 'modules/community/types/post-attachment'

export const galleryFactory = (attachment: PostAttachmentType): ReactNode => {
  switch (attachment.type) {
    case AttachmentTypeEnum.Image:
    case AttachmentTypeEnum.EmbeddedImage: {
      return <ImageGalleryPreview key={attachment.id} attachment={attachment} />
    }
    case AttachmentTypeEnum.Video: {
      return <VideoGalleryPreview key={attachment.id} attachment={attachment} />
    }
    case AttachmentTypeEnum.EmbeddedVideo: {
      return <EmbeddedVideoGalleryPreview key={attachment.id} attachment={attachment} />
    }
    case AttachmentTypeEnum.EmbeddedGif: {
      return <GifGalleryPreview key={attachment.id} attachment={attachment} />
    }
    // NOTE: Audio not supported for view in gallery. If you change it, change the function that depends on it - filterNotGalleryAttachments
    case AttachmentTypeEnum.Audio: {
      return null
    }
    default: {
      return null
    }
  }
}
